import React from 'react'
import ScanLicense from '../ScanLicense'
import api from '../../api'
import getCountryCode from '../../helpers/country-code'
import * as Sentry from '@sentry/react'

// eslint-disable-next-line react/prop-types
export function LicenseScan({ waiverId, nextStep, setPayload, waiverModelScan, setLicensePayload }) {
  async function submitScan(frontPic, backPic) {
    try {
      if (frontPic) {
        const { isDecoded, waiverData } = await api.scans.postLicense(frontPic)
        if (isDecoded) {
          waiverData.country = getCountryCode(waiverData.country)
          setPayload((prevData) => ({
            ...prevData,
            ...waiverData,
            driversLicenseFrontPic: frontPic
          }))

          setLicensePayload((prevData) => ({
            ...prevData,
            ...waiverData,
            driversLicenseState: waiverData.state,
            driversLicenseFrontPic: frontPic,
            waiverId
          }))
        } else {
          setPayload((prevData) => ({ ...prevData, driversLicenseFrontPic: frontPic }))
        }
      } else {
        const { isDecoded, waiverData } = await api.scans.postLicense(backPic)
        if (isDecoded) {
          waiverData.country = getCountryCode(waiverData.country)
          setPayload((prevData) => ({
            ...prevData,
            ...waiverData,
            driversLicenseBackPic: backPic
          }))

          setLicensePayload((prevData) => ({
            ...prevData,
            ...waiverData,
            driversLicenseBackPic: backPic
          }))
        } else {
          setPayload((prevData) => ({ ...prevData, driversLicenseBackPic: backPic }))
        }
      }
    } catch (error) {
      Sentry.captureException(`DL recognition failed with error ${error} (frontPic=${!!frontPic}, backPic=${!!backPic})`)
      if (frontPic) {
        setPayload((prevData) => ({ ...prevData, driversLicenseFrontPic: frontPic }))
      }
    }
    nextStep()
  }

  return <ScanLicense onSkip={nextStep} onComplete={submitScan} snapshot={false} waiverModelScan={waiverModelScan} />
}
